import { useEffect, useState } from "react";
import { LoadCountries } from "../services/CountryService";
import { ICountry } from "../utils/types";

export const useCountries = () => {
  const [countries, setCountries] = useState<ICountry[]>([] as ICountry[]);
  let errorResult;
  useEffect(() => {
    async function Countries() {
      await LoadCountries().then(response => {
        if (Array.isArray(response.data)) {
          const cntry = response.data as ICountry[];
          setCountries(cntry);
        }
      }).catch(err => {
        errorResult = err;
      });
    }
    Countries();
  }, []);
  return { countries, errorResult };
};
